import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

const ImageComponent = ({ alt, className, loading, src, ...props }) => {
  let altText = alt
  let imageSrc = src
  if (!altText || altText.length === 0) {
    altText = 'EA Kliniken Image'
  }

  if (typeof src === 'object') {
    if (src.gatsbyImageData) {
      return (
        <GatsbyImage
          alt={altText}
          className={className}
          image={{ ...src.gatsbyImageData }}
          loading={loading}
          placeholder="none"
          quality={100}
          {...props}
        />
      )
    }
    if (src.url) {
      imageSrc = src.url
    } else {
      return null
    }
  }

  return <img alt={alt} className={className} src={imageSrc} {...props} />
}

export default ImageComponent
